import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './design/tokens.css';
import { App } from './App.tsx';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root. index.html has been altered.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
